export default __webpack_public_path__ + "static/media/questionMark.9fc34738.svg";